// 프로젝트(목록·선택·설정 모달·지식문서) CRUD. core의 프로젝트 선택/코워크 + 대화(startNew/reload)·
// 작업공간(loadWorkspaceFiles/setWorkspaceFiles)을 주입받아 선택 시 새 대화·작업공간 동기화.
import { useState, useEffect } from 'react';
import { projectAPI, historyAPI } from '../../../api/client';
import { alertDialog, confirmDialog } from '../../../components/AppDialog';

export default function useProjects({
  selectedProjectId, setSelectedProjectId, cowork, setCowork,
  startNew, setConversations, loadWorkspaceFiles, setWorkspaceFiles,
}) {
  const [projects, setProjects]           = useState([]);
  const [projModal, setProjModal]         = useState(null);   // 프로젝트 설정 모달 { id, name, instructions }
  const [projFiles, setProjFiles]         = useState([]);
  const [showNewProj, setShowNewProj]     = useState(false);
  const [newProjName, setNewProjName]     = useState('');

  useEffect(() => { projectAPI.list().then((r) => setProjects(r.data)).catch(() => {}); }, []);

  const reloadProjects = () => projectAPI.list().then((r) => setProjects(r.data)).catch(() => {});
  const selectProject = (pid) => {
    setSelectedProjectId(pid);
    startNew();
    if (!pid) { setCowork(false); setWorkspaceFiles([]); }
    else if (cowork) loadWorkspaceFiles(pid);
  };
  const createProject = async () => {
    const name = newProjName.trim();
    if (!name) return;
    try {
      const r = await projectAPI.create({ name });
      await reloadProjects();
      setShowNewProj(false);
      setNewProjName('');
      selectProject(r.data.id);
    } catch { alertDialog('프로젝트 생성에 실패했습니다.'); }
  };
  const openProjSettings = async (p) => {
    // role 은 공유 관리(owner 전용) 노출 판단에 쓴다 — 목록 응답의 판정과 동일하게 읽는다.
    const role = p.access_role || p.role || (p.shared ? 'viewer' : 'owner');
    setProjModal({ id: p.id, name: p.name, instructions: p.instructions || '', role });
    try { const r = await projectAPI.listFiles(p.id); setProjFiles(r.data); } catch { setProjFiles([]); }
  };
  const saveProjSettings = async () => {
    try {
      await projectAPI.update(projModal.id, { name: projModal.name, instructions: projModal.instructions });
      await reloadProjects();
      setProjModal(null);
    } catch { alertDialog('저장에 실패했습니다.'); }
  };
  const deleteProject = async () => {
    if (!(await confirmDialog('프로젝트를 삭제하시겠습니까? 소속 대화는 일반 대화로 이동합니다.', { danger: true }))) return;
    try {
      await projectAPI.remove(projModal.id);
      if (selectedProjectId === projModal.id) setSelectedProjectId(null);
      await reloadProjects();
      historyAPI.listConversations().then((r) => setConversations(r.data)).catch(() => {});
      setProjModal(null);
      startNew();
    } catch { alertDialog('삭제에 실패했습니다.'); }
  };
  const uploadProjFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file || !projModal) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      await projectAPI.uploadFile(projModal.id, fd);
      const r = await projectAPI.listFiles(projModal.id);
      setProjFiles(r.data);
    } catch (err) { alertDialog(err.response?.data?.detail || '파일 업로드에 실패했습니다.'); }
  };
  const deleteProjFile = async (fid) => {
    try {
      await projectAPI.deleteFile(fid);
      const r = await projectAPI.listFiles(projModal.id);
      setProjFiles(r.data);
    } catch { alertDialog('삭제에 실패했습니다.'); }
  };

  return {
    projects, reloadProjects, projModal, setProjModal, projFiles, showNewProj, setShowNewProj,
    newProjName, setNewProjName, selectProject, createProject, openProjSettings, saveProjSettings,
    deleteProject, uploadProjFile, deleteProjFile,
  };
}
